var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import IonLogo from "@/assets/icons/ion-logo.svg";
import RockLogo from "@/assets/icons/rock-logo.svg";
import StageLogo from "@/assets/icons/stage-logo.svg";
import StudioLogo from "@/assets/icons/studio-logo.svg";
import { Popup } from "@/shared/presentation/components/popup";
import { NotificationBar } from "@/shared/presentation/containers/shell/notification-bar";
import { NotificationContext } from "@/shared/presentation/context-api/providers/notification";
import { AppDrawer, Home, Person, Wallet, Store } from "@reverb-ui/icons-react";
import { Avatar, Box, Center, Flex, Grid, HStack, Menu, MenuButton, MenuItem, MenuList, SimpleGrid, Tag, Text, useColorModeValue, } from "@reverb-ui/react";
import { NavBar, NavIconButton, SideBar } from "@reverb-ui/rock-suite";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { Link as RouterLink, useRouteMatch } from "react-router-dom";
import LogoIcon from "../../../../assets/icons/logo.svg";
import { ChooseLanguage } from "../../components/choose-language/choose-language";
import { AuthContext } from "../../context-api/providers/auth";
import { UserPermissionContext } from "../../context-api/providers/user-permission";
import { ProfileMenu } from "./profile-menu";
import DollarSignDisabled from "../../../../assets/icons/dollar-sign-disabled.svg";
import DollarSign from "../../../../assets/icons/dollar-sign.svg";
import { useFlag } from "@unleash/proxy-client-react";
var ENVIRONMENT_RUNNING = process.env.ENVIRONMENT_RUNNING;
var ShellButton = function (_a) {
    var icon = _a.icon, to = _a.to, ariaLabel = _a.ariaLabel;
    var match = useRouteMatch(to);
    return (React.createElement(NavIconButton, __assign({ "aria-label": ariaLabel, icon: icon, as: RouterLink, matchRouter: match }, {
        to: to,
    })));
};
// const environment = process.env.ENVIRONMENT_RUNNING;
var AppDrawerButton = function (_a) {
    var icon = _a.icon, title = _a.title, redirectUrl = _a.redirectUrl, pt = _a.pt, sameTab = _a.sameTab, pb = _a.pb;
    var navigateToPlatform = function (url) {
        window.open(url, "_blank");
    };
    return (React.createElement(MenuItem, { onClick: function () {
            if (sameTab) {
                window.location.href = redirectUrl;
            }
            else {
                navigateToPlatform(redirectUrl);
            }
        }, _hover: { bg: "none" } },
        React.createElement(Center, { w: "75px", flexDirection: "column", _hover: { bg: "blue.50", borderRadius: 8, transition: "0.1s" } },
            React.createElement(Center, { h: "50px", w: "50px" }, icon),
            React.createElement(Text, { fontSize: "md", mt: "1", color: "black" }, title))));
};
export var Shell = function (_a) {
    var _b;
    var children = _a.children;
    var t = useTranslation("shell").t;
    var _c = useContext(UserPermissionContext), hasPermission = _c.hasPermission, permissions = _c.permissions;
    var _d = useContext(AuthContext), clientWallets = _d.clientWallets, talentWalletId = _d.talentWalletId, simulatedEmail = _d.simulatedEmail, user = _d.user;
    var clientWalletId = (_b = clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets[0]) === null || _b === void 0 ? void 0 : _b.walletUuid;
    var _e = useContext(NotificationContext), notifications = _e.notifications, readNotifications = _e.readNotifications;
    var _f = useState(null), openedNotification = _f[0], setOpenedNotification = _f[1];
    var _g = useState(false), setCanShowAssignTeam = _g[1];
    var history = useHistory();
    var backgroundColor = useColorModeValue("blue.50", "gray.800");
    var backgroundColorSideBar = useColorModeValue("white", "gray.800");
    // const backgroundEnvironment = useColorModeValue("red.500", "red.800");
    useEffect(function () {
        setCanShowAssignTeam(hasPermission(process.env.PERMISSION_WALLET_CS_REBALANCE));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissions]);
    var isMarketplace = useRouteMatch("/marketplace");
    var showBadge = !isMarketplace && (ENVIRONMENT_RUNNING || simulatedEmail);
    var readMessages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ids;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ids = notifications.data
                        .filter(function (notification) { return !notification.read; })
                        .map(function (notification) { return notification.recipientId; });
                    if (ids.length === 0)
                        return [2 /*return*/];
                    return [4 /*yield*/, readNotifications(ids, new Date())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var isFinancialPage = function () {
        var locationHref = window.location.href;
        var hasFinancial = locationHref.indexOf("financial");
        return hasFinancial !== -1;
    };
    var showMarketplaceIntegration = useFlag("account.marketplace-integration");
    return (React.createElement(Box, { h: "100vh", w: "100vw", bg: backgroundColor },
        React.createElement(Grid, { h: "100vh", templateRows: "auto 1fr", templateColumns: "100vw" },
            React.createElement(NavBar, { logoIcon: React.createElement(LogoIcon, null), logoText: "Rock Account", bg: backgroundColorSideBar },
                React.createElement(HStack, { gridColumnGap: "2" },
                    React.createElement(ChooseLanguage, null),
                    React.createElement(Menu, { autoSelect: false }, function (_a) {
                        var isOpen = _a.isOpen;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(MenuButton, { as: Box, mr: "4", cursor: "pointer", _expanded: { bg: "#F5F8FF" }, borderRadius: "5", p: "1.5" },
                                React.createElement(AppDrawer, { size: "md", color: isOpen ? "blue.500" : "black" })),
                            React.createElement(MenuList, { py: 4 },
                                React.createElement(SimpleGrid, { columns: 3, spacing: 0 },
                                    React.createElement(AppDrawerButton, { icon: React.createElement(Avatar, { name: user === null || user === void 0 ? void 0 : user.name }), sameTab: true, title: "Account", redirectUrl: process.env.APP_BASE_URL }),
                                    React.createElement(AppDrawerButton, { icon: React.createElement(StudioLogo, null), title: "Studio", redirectUrl: process.env.LOGIN_URL + "/?origin=https://studio.rockcontent.com/&platform=studio" }),
                                    !talentWalletId && (React.createElement(React.Fragment, null,
                                        React.createElement(AppDrawerButton, { icon: React.createElement(StageLogo, null), title: "Stage", redirectUrl: process.env.LOGIN_URL + "/?origin=https://rockstage.io/app/blogs&platform=stage" }),
                                        React.createElement(AppDrawerButton, { icon: React.createElement(IonLogo, null), title: "Ion", redirectUrl: process.env.LOGIN_URL + "/?origin=https://login.ion.rockcontent.com/login&platform=ion" }),
                                        React.createElement(AppDrawerButton, { icon: React.createElement(RockLogo, null), title: "Live", redirectUrl: "https://live.rockcontent.com" }))),
                                    React.createElement(AppDrawerButton, { icon: React.createElement(RockLogo, null), title: "RockU", redirectUrl: "https://university.rockcontent.com" }),
                                    talentWalletId && (React.createElement(AppDrawerButton, { icon: React.createElement(RockLogo, null), title: "GTN", redirectUrl: "https://gtn.rockcontent.com" }))))));
                    }),
                    React.createElement(NotificationBar, { notifications: notifications.data.slice(0, 5), readMessages: readMessages, seeAllNotifications: function () { return history.push("/notifications"); }, onOpen: setOpenedNotification }),
                    React.createElement(ProfileMenu, null))),
            React.createElement(Grid, { templateColumns: "55px 1fr", templateRows: "1fr", overflow: "hidden" },
                React.createElement(SideBar, { height: "full", w: "55px", position: "initial", bg: backgroundColorSideBar },
                    React.createElement(ShellButton, { ariaLabel: t("home"), to: "/home", icon: React.createElement(Home, { size: "md" }) }),
                    React.createElement(ShellButton, { ariaLabel: t("my account"), to: "/my-account", icon: React.createElement(Person, { size: "md" }) }),
                    (talentWalletId || clientWalletId) && (React.createElement(ShellButton, { ariaLabel: t("wallet"), to: "/wallet", icon: React.createElement(Wallet, { size: "md" }) })),
                    talentWalletId && (React.createElement(ShellButton, { ariaLabel: t("financial"), to: "/financial", icon: !!isFinancialPage() ? React.createElement(DollarSign, null) : React.createElement(DollarSignDisabled, null) })),
                    showMarketplaceIntegration && clientWalletId && (React.createElement(ShellButton, { ariaLabel: "Marketplace", to: "/marketplace", icon: React.createElement(Store, { size: "md" }) }))),
                React.createElement(Box, { overflowY: "auto", borderWidth: showBadge ? "2px" : "0", borderColor: showBadge ? "red.500" : "transparent" },
                    showBadge && (React.createElement(Flex, { justifyContent: "space-between", pt: "5", w: "100%", px: "16" },
                        simulatedEmail && (React.createElement(Flex, { flex: "1", fontWeight: "medium", fontSize: "sm" },
                            React.createElement(Text, { pr: "1", color: "gray.500" }, "Simulating"),
                            React.createElement(Text, { color: "red.500" }, simulatedEmail))),
                        ENVIRONMENT_RUNNING && (React.createElement(Tag, { color: "red.500", bg: "red.50", fontWeight: "bold" }, ENVIRONMENT_RUNNING)))),
                    children))),
        React.createElement(Popup, { title: openedNotification === null || openedNotification === void 0 ? void 0 : openedNotification.subject, message: openedNotification === null || openedNotification === void 0 ? void 0 : openedNotification.message, onClose: function () { return setOpenedNotification(null); }, isOpen: !!openedNotification })));
};
